import { Box, Button, Circle } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { calculateDateRange, getRandomEmployees } from "../../redux/actions/actions";
import MobileCourseCard from "./MobileCourseCards";
import { ReactComponent as PlusIcon } from '../../svg/plusIcon.svg'
import { deleteCourse } from "../../redux/api_calls/apiCalls";
import { useHistory } from "react-router-dom";

export default function MobileAllCourses({ courses, method, loadMoreVisible }) {
    const dispatch = useDispatch()
    const history = useHistory()

    const deleteHandler = (id) => {
        let updatedCourses = courses.filter(course => course.id !== id)
        let courseToRemove = courses.find(course => course.id === id)
        dispatch(deleteCourse(updatedCourses, id, courseToRemove))
    }
    return (
        <Box width='90%' flexDirection='column' justifyContent='space-between' alignItems='center' d={['flex', 'flex', 'flex','flex', 'none']}  >
            {
                courses.map((course) => <MobileCourseCard
                    name={course.title}
                    dates={calculateDateRange(course.start_date, course.end_date)}
                    certifiedEmployee={getRandomEmployees()}
                    enrolledEmployee={getRandomEmployees()}
                    topics={course.topics_count}
                    id={course.id}
                    key={course.id}
                    removeCourse={deleteHandler}
                    {...course}
                />)
            }
            {
                loadMoreVisible &&
                <Button
                    color='#00000099'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='700'
                    fontSize={['14px', '16px', '18px', '20px']}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    boxShadow='0px 3px 16px rgba(0, 0, 0, 0.1)'
                    borderRadius='xl'
                    py={['0.5rem', '0.75rem', '1rem', '1.5rem']}
                    px={['0.75rem', '1rem', '1.5rem', '2rem']}
                    m='2rem'
                    bg='#ffffff'
                    onClick = {method}
                >
                    Load More...
                </Button>
            }

            <Circle
                position='fixed'
                right='10vw'
                bottom='5vh'
                size='50px'
                cursor='pointer'
                bg='#fd5f3a'
                fontSize='48px'
                color='white'
                onClick={() => history.push('/add-courses')}
                boxShadow='0px 14.2857px 17.8571px rgba(0, 0, 0, 0.14), 0px 3.57143px 35.7143px rgba(0, 0, 0, 0.12), 0px 7.14286px 14.2857px rgba(0, 0, 0, 0.2)'
            >
                <PlusIcon />
            </Circle>
        </Box>
    )
}